module.exports = __webpack_public_path__ + "assets/images/pages/eu-funds/ifi-innova.png?97eeec79";